module.exports = __webpack_public_path__ + "static/color-wheel-0ec9cfa26a7ef5126effe5b9129f7df5.png";